(function (algolia) {
  'use strict';

  algolia.translations = {
    search: "Huidige zoekopdracht", //"Current search",
    noCollectionFound: "Geen collectie gevonden", //"No collection found",
    allProducts: "Bekijk alle producten", //"See all products",
    matching: "Passend", //"matching",
    sortBy: "Sorteer op", //"Sorted by",
    relevance: "Relevantie", //"Relevance",
    outOf: "van", //"out of",
    resultsFound: "resultaten", //"results found",
    oneResultFound: "1 resultaat", //"1 result found",
    noResultFound: "Geen resultaten", //"No result found",
    addToCart: "Toevoegen aan winkelwagen", //"Add to cart",
    searchForProduct: "Zoek producten", //"Search for products",
    selectedFilter: "Gekozen filters", //"Selected filters",
    clearAll: "Wissen", //"Clear all",
    noPageFound: "Geen pagina gevonden", //"No page found",
    outOfStock: "Uitverkocht", //"Out of stock",
    priceRange: "PRIJS",
  };

  algolia.translation_helpers = {
    no_result_for: function (text, render) {
      return 'Geen resultaat voor zoekopdracht ' + render(text); //'No result for query ' + render(text) + '';
    },
    in: function (text, render) {
      return 'in ' + render(text) + 's';
    },

    try_clear_or_change_input: function (text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);

      return 'Probeer ' + render(html_tags[0]) + ' filters te resetten ' + render(html_tags[1]) + ' of ' + render(html_tags[2]) + ' de zoekopdracht te wijzigen ' + render(html_tags[3]) + '';
      //return 'Try ' + render(html_tags[0]) + ' clearing filters ' + render(html_tags[1]) + ' or ' + render(html_tags[2]) + ' changing your input ' + render(html_tags[3]) + '';
    },
    outOf: function (text, render) {
      return '' + render(text) + ' van';//'' + render(text) + ' out of';
    },

    by: function (text, render) {
      return 'door ' + render(text) + '';//'by ' + render(text) + '';
    }
  };

}(algoliaShopify));
